import { atomFamily } from 'recoil';

var UploadKey;
(function (UploadKey) {
    UploadKey["IMPORT"] = "import";
})(UploadKey || (UploadKey = {}));
/**
 * All uploaded descriptors for cleanup.
 */
var uploadFileDescriptorsAtom = atomFamily({
    key: "UploadFileDescriptorsAtom",
    "default": []
});
/**
 * Media imports without progress.
 * Useful to display medias to import.
 */
var kpkMediaImportsAtom = atomFamily({
    key: "KpkMediaImportsAtom",
    "default": []
});
/**
 * Media imports with progress.
 * Useful to display media progress information.
 * This will update frequently.
 */
var kpkMediaImportsProgressAtom = atomFamily({
    key: "KpkMediaImportsProgressAtom",
    "default": []
});
/**
 * Callback to open upload dialog.
 */
var openUploadDialogAtom = atomFamily({
    key: "OpenUploadDialogAtom",
    "default": function () { }
});

export { UploadKey, kpkMediaImportsAtom, kpkMediaImportsProgressAtom, openUploadDialogAtom, uploadFileDescriptorsAtom };
//# sourceMappingURL=atoms.js.map
